import * as React from "react";
import { singleton } from "logic/singleton";
const WidgetEditApplyAllChangesContext = React.createContext({
  applyAllWidgetChanges: () => Promise.resolve(),
  bindApplyElementConfigurationChanges: () => {
  },
  bindApplySearchControlsChanges: () => {
  }
});
export default singleton("contexts.WidgetEditApplyAllChangesContext", () => WidgetEditApplyAllChangesContext);
